<template>
  <div style="height: 100%" class="div_consult_apply">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="ConsultQuoteApplyTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" :loading_width="50" @on_query="on_query"
        @state_change="state_change" @on_cell_button_click="on_cell_button_click" :show_toolbar_button="[1, 1, 0, 0, 1]"
        :table_height_adjust="-6" :show_toolbar_state="false" :hb_table_class="'hb_table_cqeapply_class1'"
        :only_text="$t('common.show_all')" @only_methods="only_methods" tableref="7e6a5074871245e79e930d2602532b8f">
        <template #query>
          <el-select v-model="QuotationType" placeholder="报价类型" size="small" style="width: 100px" clearable>
            <el-option label="大货报价" value="大货报价"></el-option>
            <el-option label="打样报价" value="打样报价"></el-option>
          </el-select>
          <el-input placeholder="询价申请编号" class="ml-1" clearable size="small" style="width: 12rem"
            v-model="search_obj.ConsultQuoteApplyNum"></el-input>
          <el-input placeholder="报价申请编号" class="ml-1" clearable size="small" style="width: 12rem"
            v-model="search_obj.QuotationTaskNum"></el-input>
          <el-input placeholder="物料编号" class="ml-1" clearable size="small" style="width: 10rem"
            v-model="search_obj.ItemId"></el-input>
          <el-input placeholder="物料名称" class="ml-1" clearable size="small" style="width: 14rem"
            v-model="search_obj.NameAlias"></el-input>
        </template>
        <template #toolbar>
          <el-button type="info" plain @click="createData()" class="ml-2 iconfont icon-add-new" size="mini"> 新建询价申请
          </el-button>
          <el-button type="info" plain @click="createConsultData()" class="ml-2 iconfont icon-add-new" size="mini">
            新建询价单
          </el-button>
          <el-popover placement="right" title="提示" width="250" trigger="hover" content="默认显示没有询过价的申请！"
            style="border-color: red;">
            <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
          </el-popover>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 新建 -->
    <el-drawer :title="drawer_consult_apply_title" :visible.sync="drawer" :with-header="true" :size="'65%'"
      :before-close="handleClose">
      <SplitContainer21 style="height:100%" :layout="12" :split_setting="0.5">
        <template #top>
          <TableMain ref="ConsultQuoteApplyTable2" :show_query_container="false" :show_date_picker="false"
            :fields="inventTable_fields" :table_height_adjust="8" :title="table_title.title2"
            :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
            :pager_count="5" :isBusy="isBusy2" :hb_table_class="'hb_table_cqea_class2'" :show_filter="false"
            :show_toolbar_state="false" tableref="917a6a09263c48099c973c93b4941eb3">
            <template #toolbar>
              <el-input class="ml-2" style="width:200px" clearable v-model="quotation_task_num"
                placeholder="请输入报价申请单编号"></el-input>
              <el-button type="primary" plain class="ml-2" @click="InventQuery"><i
                  class="iconfont icon-search"></i>&nbsp;&nbsp;{{ $t("common.query") }}
              </el-button>
              <el-input style="width:300px;margin-left: 25rem;" clearable v-model="filter_invent_name_key"
                placeholder="请输入物料名称关键字(多条件以*号关联)" @change="InventInputChanged"></el-input>
            </template>
            <template #operation>
              <el-select v-model="applicationQuotationType" size="small" style="width: 150px" clearable filterable
                :placeholder="'请选择报价类型'">
                <el-option label="大货报价" value="大货报价"></el-option>
                <el-option label="打样报价" value="打样报价"></el-option>
              </el-select>
              <el-button type="info" plain class="ml-2" @click="getInventIntoDetail"><i
                  class="iconfont icon-down2"></i>&nbsp;&nbsp;{{ $t("common.selected") }}
              </el-button>
            </template>
          </TableMain>
        </template>
        <template #bottom>
          <TableMain ref="ConsultQuoteApplyTable3" :fields="detail_fields" :show_query_container="false"
            :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="2"
            :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3" :loading_width="90"
            @state_change="detail_state_change" @on_cell_button_click="on_cell_button_click"
            :show_toolbar_button="[0, 0, 0, 0, 1]" :show_toolbar_state="false" :hb_table_class="'hb_table_cqea_class3'" tableref="9b186f7de4604157b4e48dfd07eacebc">
            <template #operation>
              <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
                @on_query="Detail_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
            </template>
          </TableMain>
        </template>
      </SplitContainer21>
    </el-drawer>
    <!-- 附件 -->
    <el-dialog title="附件管理" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" :close-on-click-modal="false"
      @opened="dialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'ConsultQuote'" :showUpload="isShowUpload"
        @setAccessory="setAccessory">
      </FileUpload>
    </el-dialog>
    <!-- 询价单 -->
    <BaseModal ref="QTModal" :title="qt_modal_title" @saveData="SaveDataConsult" :width="'35%'">
      <template #modal_content>
        <el-form ref="dataForm" label-width="100px" class="demo-dataForm" style="height: 200px">
          <el-col :span="24">
            <el-form-item label="描述">
              <el-input type="textarea" v-model="ConsultOrderDescription" clearable rows="8"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import * as InventTableController from "../../controllers/base/InventTableController"
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import FileUpload from "../FileUpload.vue"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import SplitContainer21 from "../components/container/SplitContainer21"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    BaseContainer,
    SplitContainer21,
    TableMain,
    QueryButton,
    FileUpload,
    BaseModal
  },
  data() {
    return {
      date_picker_label: "创建时间",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_consult_quote_application",
        title2: "table_invent",
        title3: "table_consult_quote_application_detail",
      },
      fields: _.cloneDeep(ConsultQuoteConttroller.fields.application),
      detail_fields: _.cloneDeep(ConsultQuoteConttroller.fields.application),
      inventTable_fields: ConsultQuoteConttroller.fields.inventTable_fields,
      drawer_consult_apply_title: "",
      search_obj: {
        ConsultQuoteApplyNum: "",
        QuotationTaskNum: "",
        ItemId: "",
        NameAlias: "",
      },
      drawer: false,
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      InventListHis: [],
      QuoteTaskItemsHis: [],
      filter_invent_name_key: "",
      quotation_task_num: "",
      current_accessory: null, ///当前派单选中附件
      accessoryVisible: false,
      qt_modal_title: "",
      ConsultOrderDescription: "",
      isShowUpload: true,
      query_date: [],
      QuotationType: "",
      applicationQuotationType: ""
    }
  },
  created() {
    this.fields = _.filter(this.fields, (t) => { delete t.editable; return t })
    let invalidFields = ["id", "create_by", "create_at", "ConsultQuoteApplyNum", "is_valid"]
    this.detail_fields = _.filter(this.detail_fields, (t) => {
      return !_.includes(invalidFields, t.key)
    })
  },
  mounted() { },
  methods: {
    only_methods(only_value) {
      this.on_query(this.$refs.ConsultQuoteApplyTable1.SetData, this.query_date, false)
    },
    async on_query(set_data, _date, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }

      let p = {}
      if (_date && _date.length > 0) {
        this.query_date = _date
        let _fromDate = this.$date.format(_date[0], "yyyy-MM-dd")
        let _toDate = this.$date.format(_date[1], "yyyy-MM-dd")
        p["date_from"] = _fromDate
        p["date_to"] = _toDate
      }
      for (var key in this.search_obj) {
        if (this.search_obj[key] != "") {
          this.search_obj[key] = _.trim(this.search_obj[key])
          if (key == "NameAlias")
            p[key] = "%" + this.search_obj[key] + "%"
          else
            p[key] = this.search_obj[key]
        }
      }

      let _result = await ConsultQuoteConttroller.methods.getDataApply(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["ConsultQuoteApplyNum", "LineNum"], ["desc", "asc"])
        if (this.QuotationType !== "") {
          dt = _.filter(dt, (t) => t.quotationType == this.QuotationType)
        }

        if (!this.$refs.ConsultQuoteApplyTable1.only_value)
          dt = _.filter(dt, { hasConsultOrder: false })
        _.each(dt, (t) => {
          t.AccessoryCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
        })
        set_data(dt)
      }
      this.isBusy = false
    },
    ///状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }
      let p = {}
      if (data.state == "valid" || data.state == "invalid") {
        let dt = _.filter(data.selected_items, (t) => { return t.is_valid == !(data.state == "valid") })
        p.edit = _.map(dt, (t) => { return { id: t.id, is_valid: data.state == "valid" } })
      }
      else if (data.state == "deleted") {
        p.delete = data.selected_items
      }
      let rt = await ConsultQuoteConttroller.methods.saveDataDetailApply(p)
      if (rt) {
        if (data.state == "deleted")
          this.$refs.ConsultQuoteApplyTable1.RemoveItems(rt[0])
        else
          await this.on_query(this.$refs.ConsultQuoteApplyTable1.SetData, this.query_date, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    ///新增、编辑
    createData() {
      this.drawer_consult_apply_title = "新建询价申请"
      this.drawer = true
    },
    async InventQuery() {
      this.$refs.ConsultQuoteApplyTable2.SetData([])
      if (this.quotation_task_num == "") {
        this.inventTable_fields = ConsultQuoteConttroller.fields.inventTable_fields
        if (this.InventListHis.length > 0) {
          let isReload = await this.$confirm('检测到上次查询所有物料，是否需要重新获取所有物料?', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }).then(() => {
            return true
          }).catch(() => {
            return false
          })
          if (isReload) await this.InventQueryAll()
          else this.$refs.ConsultQuoteApplyTable2.SetData(this.InventListHis)
        }
        else await this.InventQueryAll()
      }
      else {
        await this.Get_Quote_Detail()
      }
    },
    //查询物料
    async InventQueryAll(CustAccount, dataAreaId) {
      this.isBusy2 = true
      let p = {}
      p.dataAreaId = dataAreaId
      let _result = await InventTableController.methods.getSOInventData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["createdDateTime"], ["desc"])
        this.InventListHis = _.uniqBy(dt, "ItemId")
        this.$refs.ConsultQuoteApplyTable2.SetData(_.uniqBy(dt, "ItemId"))
      }
      this.isBusy2 = false
    },

    ///直接新增明细行
    Detail_CreateData(im) {
      let items_length = this.$refs.ConsultQuoteApplyTable3.my_data.length
      let newItems = [], m = {}
      if (items_length == 0) {
        m["LineNum"] = items_length + 1
      }
      else {
        let last_m = _.last(this.$refs.ConsultQuoteApplyTable3.my_data)
        m["LineNum"] = last_m.LineNum + 1
      }
      console.log(im)
      if (im) {
        _.each(this.detail_fields, (t) => {
          if (im[t.key]) m[t.key] = im[t.key]
        })
        m["QuotationTaskDetailId"] = im["QuotationTaskDetailId"]
      }
      m.id = ""
      m.ConsultQuoteApplyNum = ""
      m.AccessoryCount = 0
      if (m.Accessory && m.Accessory != "")
        m.AccessoryCount = JSON.parse(m.Accessory).length
      m.quotationType = this.applicationQuotationType
      newItems.push(m)
      console.log(newItems)
      let _ex = _.filter(this.$refs.ConsultQuoteApplyTable3.my_data, (t) =>
        t.ItemId == m.ItemId &&
        t.dataAreaId == m.dataAreaId &&
        t.FromBatchQty == m.FromBatchQty &&
        t.BatchQty == m.BatchQty
      )
      if (_ex && _ex.length == 0)
        this.$refs.ConsultQuoteApplyTable3.AppendItems(newItems)
    },
    ///将选中物料添加到明细
    getInventIntoDetail() {
      let selected_invent_data = this.$refs.ConsultQuoteApplyTable2.GetSelectedItems()
      if (selected_invent_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      if (this.applicationQuotationType === '') {
        this.msgToasts("请选择报价类型", "info")
        return
      }
      _.each(selected_invent_data, (t) => {
        this.Detail_CreateData(t)
      })
    },
    ///明细状态切换
    async detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        ///删除文件
        // for (var i in data.selected_items) {
        //   let t = data.selected_items[i];
        //   if (t.Accessory && t.Accessory != "") {
        //     let gt = await FileUploadController.methods.getDataByJson({ json: t.Accessory });
        //     if (gt) {
        //       let del_acc_dt = _.map(gt[0], (m) => { return { id: m.id } })
        //       let rt = await FileUploadController.methods.saveData({ delete: del_acc_dt });
        //       if (rt) {
        //         for (var j in gt[0]) {
        //           let ft = gt[0][j];
        //           let _idx = ft.FilePath.split("&")[0].split("=")[1];
        //           let p = { category: ft.Category, code: ft.Code, idx: _idx, fileName: ft.FileName };
        //           await FileUploadController.methods.deleteFromAzure(p);
        //         }
        //       }
        //     }
        //   }
        // }
        this.$refs.ConsultQuoteApplyTable3.RemoveItems(data.selected_items)
      }

    },
    ///保存明细
    async Detail_SaveData(cb) {
      //数据验证
      let msg = "", p = { add: [], edit: [] }
      let detail_data = this.$refs.ConsultQuoteApplyTable3.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }
      let require_fileds = _.map(_.filter(this.detail_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        delete m.CompanyName
        delete m.CostGroupId
        delete m.DW_ItemGroupId
        delete m.TEC_SpecType
        delete m.AccessoryCount
        if (m.id == "") {
          delete m.id
          p.add.push(m)
        }
        else { p.edit.push(m) }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      let rt = await ConsultQuoteConttroller.methods.saveDataDetailApply(p)
      if (rt) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.$refs.ConsultQuoteApplyTable3.SetData([])
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion
    //物料名称关键字
    InventInputChanged() {
      let dt = this.InventListHis
      if (this.quotation_task_num != "") {
        dt = this.QuoteTaskItemsHis
      }
      if (this.filter_invent_name_key != "" && dt && dt.length > 0) {
        let keys = this.filter_invent_name_key.split("*")
        let reg = ".*" + _.join(keys, ".*.") + ".*"
        let fdt = _.filter(dt, (t) => {
          if (t.NameAlias.match(reg)) {
            return t
          }
        })
        this.$refs.ConsultQuoteApplyTable2.SetData(fdt)
      }
      else {
        this.$refs.ConsultQuoteApplyTable2.SetData(this.InventListHis)
      }
    },

    ///查询报价明细
    async Get_Quote_Detail() {
      this.isBusy2 = true
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = this.quotation_task_num
      let _result = await QuotationTaskController.methods.getDetailDataBySql(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], (t) => { return t.IsHomemade != 0 })
        this.QuoteTaskItemsHis = _.orderBy(dt, ["LineNum"], ["asc"])
        this.$refs.ConsultQuoteApplyTable2.SetData(_.orderBy(dt, ["LineNum"], ["asc"]))
      }
      this.isBusy2 = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(t => { done() }).catch(t => { })
    },
    //#region 附件
    async on_cell_button_click(data) {
      this.isShowUpload = true
      this.current_accessory = data.item
      if (data.field.key == "Accessory") {
        if (!data.item.id || data.item.id == "")
          this.isShowUpload = false
        this.accessoryVisible = true
      }
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.ItemId)
    },
    async dialogClosed() {
      if (this.current_accessory && this.current_accessory.Accessory) {
        let ml = [], m = {
          id: this.current_accessory.id,
          Accessory: this.current_accessory.Accessory,
          QuotationTaskDetailId: this.current_accessory.QuotationTaskDetailId
        }
        if (m.id && m.id != "") ml.push(m)
        this.current_accessory.AccessoryCount = JSON.parse(this.current_accessory.Accessory).length
        await ConsultQuoteConttroller.methods.saveDataDetailApply({ edit: ml, isUpdateAccessory: true })
      }
    },
    async setAccessory(data) {
      this.current_accessory.Accessory = data
      await this.dialogClosed()
    },
    //#endregion

    //#region 创建询价单
    createConsultData() {
      let dt = this.$refs.ConsultQuoteApplyTable1.GetSelectedItems()
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      this.qt_modal_title = "新建询价单"
      _.each(this.ConsultQuoteModel, (t) => {
        switch (t.key) {
          case "Price": t.value = 0; break
          case "BatchQty": t.value = 0; break
          default: t.value = ""
        }
      })
      this.$refs.QTModal.show()
    },
    async SaveDataConsult(cb) {
      //数据验证
      let dt = this.$refs.ConsultQuoteApplyTable1.GetSelectedItems()
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(null)
        return
      }
      if (this.ConsultOrderDescription == "") {
        this.msgToasts("描述不能为空！", "info")
        cb(null)
        return
      }
      let am = {}
      am.Description = this.ConsultOrderDescription
      let p = { add: [], edit: [] }
      p.add.push(am)

      let rt = await ConsultQuoteConttroller.methods.saveData(p)
      if (rt) {
        let _lineNum = 1, items = []
        _.each(dt, (im) => {
          let m = {}
          m.LineNum = _lineNum++
          m.ItemId = im.ItemId
          m.NameAlias = im.NameAlias
          m.TEC_SpecType = im.TEC_SpecType
          m.CostGroupId = im.CostGroupId
          m.DW_ItemGroupId = im.DW_ItemGroupId
          m.ConsultQuoteApplyNum = im.ConsultQuoteApplyNum
          m.CustAccount = im.CustAccount
          m.CustName = im.CustName
          m.dataAreaId = im.dataAreaId
          m.FromQty = im.FromBatchQty
          m.ToQty = im.BatchQty
          m.DeliveryAddress = im.DeliveryAddress
          m.DeliveryMode = im.DeliveryMode
          m.TradeMode = "国内贸易"
          m.CurrencyCode = "CNY"
          m.Accessory = im.Accessory
          m.Description = im.Description
          m.QuotationTaskNum = im.QuotationTaskNum
          m.QuotationTaskDetailId = im.QuotationTaskDetailId
          m.ConsultQuoteId = rt[0].id
          m.quotationType = im.quotationType
          m.ConsultQuoteNum = rt[0].ConsultQuoteNum
          items.push(m)
        })
        await this.SaveDataConsultDetail(items)
        this.ConsultOrderDescription = ""
        cb(true, true)
      }
      else {
        cb(true, false)
      }
    },
    ///保存明细
    async SaveDataConsultDetail(detail_data) {
      //数据验证
      if (detail_data.length == 0) {
        return
      }
      let p = { add: detail_data, edit: [] }
      await ConsultQuoteConttroller.methods.saveDetailData(p)
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_cqeapply_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 195rem;
}

.hb_table_cqea_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 110rem;
}

.hb_table_cqea_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 160rem;
}

.div_consult_apply {}

.div_consult_apply .el-drawer__header {
  font-size: 1.1rem;
  /* color: black; */
}
</style>
